import { useQuery } from "@tanstack/react-query";
import { queryKeys } from "../queryKeys";
import { getPlayersByTeamId } from ".";

export const useFetchTeamPlayers = (teamId?: string) => {
  return useQuery({
    queryKey: queryKeys.teamById(teamId ?? ""),
    queryFn: teamId ? () => getPlayersByTeamId({ teamId }) : undefined,
    staleTime: 5000,
    enabled: !!teamId,
  });
};
